import { DC_COMPONENT_LABELS, PaidTimeOffPolicy } from "winslow-core";
import { DCBaseProps } from "./DCBase";
import { apiGetPaidTimeOffPoliciesForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { useSelector } from "react-redux";
import { DCBreadcrumb, selectUser } from "../../../redux/features/appData";
import { useEffect, useState } from "react";
import { AppPTOPolicies, AppPTOPoliciesNavigationActions } from "../app-time-off/AppPTOPolicies";
import { DCBreadcrumbs } from "./DCBreadcrumbs";
import { Button, Icon } from "../../../ds2/components";
import { Plus } from "lucide-react";
import { ActionLink } from "../../../ds2/components/ActionLink";
import "./DCPTOPolicies.css";
import { DCHeader } from "./DCHeader";


type DCPTOPoliciesProps = DCBaseProps & {
}

export const DCPTOPolicies = ({data, isOutdated, onNavigation}: DCPTOPoliciesProps) => {
    const storeUser = useSelector(selectUser);

    const [ptoPolicies, setPtoPolicies] = useState<PaidTimeOffPolicy[] | undefined>(undefined);

    useEffect(() => {
        if (data) {
            console.log("[DCPTOPolicy] data: ", data);
            (async () => {
                const thePolicies = await apiGetPaidTimeOffPoliciesForWorkspace(storeUser?.currentWorkspaceId || "");
                setPtoPolicies(thePolicies || []);
            })();
        }
    }, [data]);

    const navigationCallback = (
        newObjectName: DC_COMPONENT_LABELS,
        newLabel: string,
        data: any
    ) => {
        console.log("[DCPTOPolicy] navigationCallback data: ", data);
        // alert("navigationCallback: " + newObjectName + " " + newLabel);
        onNavigation?.(newObjectName, newLabel, data);
    }

    console.log("[DCPTOPolicy] data: ", data);
    console.log("[DCPTOPolicy] ptoPolicies: ", ptoPolicies);

    return (    
        <div className="dc-pto-policies">
            {/* <DCBreadcrumbs 
                breadcrumbs={[
                    {
                        objectName: "pto-policy",
                        label: "list",
                        data: data,
                        display: "PTO Policies"
                    }
                ] as DCBreadcrumb[]}
            /> */}
            <DCHeader 
                title="PTO Policies" 
                actions={[
                    // <ActionLink  
                    //     variant="tertiary"
                    //     size="sm"
                    //     leftIcon={<Plus size={16} />}
                    //     onClick={() => {
                    //         navigationCallback("pto-policy", "new", null);
                    //     }}
                    //     label="New Policy"
                    // />
                    <Button
                        variant="tertiary"
                        size="sm"
                        leftIcon={<Plus size={16} />}
                        onClick={() => {
                            navigationCallback("pto-policy", "new", null);
                        }}
                        label="Policy"
                    />
                ]}
            />
            
            {ptoPolicies && (
                <AppPTOPolicies 
                    ptoPolicies={ptoPolicies}
                    onNavigation={navigationCallback}
                />
            )}

            {/* <ActionLink  
                variant="tertiary"
                size="sm"
                leftIcon={<Plus size={16} />}
                onClick={() => {
                    navigationCallback("pto-policy", "new", null);
                }}
                label="New Policy"
            /> */}
        </div>
    )
}